import app from 'flarum/forum/app';

/**
 * Mirrors the server-side rollout switch (the server enforces it as well).
 */
export default function isEnabledFor(user) {
  switch (app.forum.attribute('splitSearchAccess')) {
    case 'everyone':
      return true;
    case 'admin':
      return !!user && !!user.isAdmin();
    default:
      return false;
  }
}
